import { useEffect, useState } from 'react';

/**
 * Minimal hash router — no dependency, no server rewrites.
 *
 * Hash routing (`#/p/atlas`) works on static hosting (CF Pages) without a
 * SPA-fallback rule, which is what the demo needs. Returns the current
 * path after the `#` (defaulting to `/`).
 */
export function useHashRoute(): string {
  const [route, setRoute] = useState(currentHashPath);
  useEffect(() => {
    const onChange = () => setRoute(currentHashPath());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function currentHashPath(): string {
  const h = window.location.hash.replace(/^#/, '');
  return h.length > 0 ? h : '/';
}

export function navigate(path: string): void {
  window.location.hash = path;
}

/** `#/p/atlas` → `atlas`; anything else → null. */
export function productIdFromRoute(route: string): string | null {
  const m = /^\/p\/([a-z0-9-]+)$/i.exec(route);
  return m ? m[1] : null;
}
